import { ITheme } from "/@/type/config/theme";
import { useLayoutStore } from "/@/store/modules/layout";

const theme: () => ITheme[] = () => {
  const { color } = useLayoutStore().getSetting;
  return [
    {
      logoBg: "#FFFFFF",
      tagsActiveColor: "#fff",
      tagsActiveBg: "#282C38",
      mainBg: "#f0f2f5",
      sidebarColor: "#757B8C",
      sidebarBg: "#FFFFFF",
      sidebarChildrenBg: "#FFFFFF",
      sidebarActiveColor: "#fff",
      sidebarActiveBg: "#0CB060",
      sidebarActiveBorderRightBG: "#FFFFFF",
      sidebarHoverColor: "#0CB060",
    },
    // {
    //   tagsActiveColor: "#fff",
    //   tagsActiveBg: color.primary,
    //   navbarColor: "#fff",
    //   navbarBg: "#393D49",
    //   mainBg: "#f0f2f5",
    //   sidebarColor: "#fff",
    //   sidebarBg: "#001529",
    //   sidebarChildrenBg: "#000c17",
    //   sidebarActiveColor: "#fff",
    //   sidebarActiveBg: color.primary,
    //   sidebarActiveBorderRightBG: "#FFFFFF",
    // },
    // {
    //   logoColor: "rgba(255,255,255,.7)",
    //   logoBg: "#50314F",
    //   navbarColor: "rgba(255,255,255,.7)",
    //   navbarBg: "#50314F",
    //   tagsColor: "#333",
    //   tagsBg: "#fff",
    //   tagsActiveColor: "#fff",
    //   tagsActiveBg: "#7A4D7B",
    //   mainBg: "#f0f2f5",
    //   sidebarColor: "rgba(255,255,255,.7)",
    //   sidebarBg: "#50314F",
    //   sidebarChildrenBg: "#382237",
    //   sidebarActiveColor: "#fff",
    //   sidebarActiveBg: "#7A4D7B",
    //   sidebarActiveBorderRightBG: "#7A4D7B",
    // },
  ];
};

export default theme;
